import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CvxHeaderComponent } from "../../shared/components/cvx-header/cvx-header.component";
import { CvxNavbarComponent } from "../../shared/components/cvx-navbar/cvx-navbar.component";
import { CvxMainComponent } from "../../shared/components/cvx-main/cvx-main.component";
// import { CvxFooterComponent } from "./shared/components/cvx-footer/cvx-footer.component";
import { APP_CONFIG } from '../../shared/constants/app-config.const';
import { MenuItem } from 'primeng/api';
import { UserProfileStore } from '../../shared/store/user-profile.store';
import { ICvxClaimsPrincipal } from '@cvx-dev/cal-angular';
import { environment } from '../../../environments/environment';
import { CalSessionService } from '../../shared/services/security/cal-session.service';
import { CalTokenService } from '../../shared/services/security/cal-token.service';

@Component({
    selector: 'app-home-page',
    imports: [CvxHeaderComponent, CvxNavbarComponent, CvxMainComponent],
    templateUrl: './home-page.component.html',
    styleUrl: './home-page.component.scss'
})
export class HomePageComponent implements OnInit, OnDestroy {
  private userProfileStore = inject(UserProfileStore);
  private calSessionService = inject(CalSessionService);
  private calTokenService = inject(CalTokenService);
  private photoObjectUrl: string | null = null;

  protected APP_CONFIG: any = APP_CONFIG;
  // protected lastSync = signal<string>('2024-10-25');
  protected profileName = computed(() => this.userProfileStore.profile()?.fullName ?? '');
  protected imagenUrl = computed(() => this.userProfileStore.profile()?.imageURL ?? '');
  protected roleName = computed(() => this.userProfileStore.profile()?.roleName ?? '');

  
  protected navbarMenuItems = signal<MenuItem[] | undefined>([
      { "label": "Home", "link": "" },
      { "label": "Landing", "link": "" },
      { "label": "Utilization", "link": "/testcomponents" },
      { "label": "Admin", "link": "#" },

   
  ]);


  constructor() {
    // No additional logic needed
  }

  ngOnInit(): void {
    void this.syncAuthenticatedUser();
  }

  ngOnDestroy(): void {
    if (this.photoObjectUrl) {
      URL.revokeObjectURL(this.photoObjectUrl);
    }
  }

  private async syncAuthenticatedUser(): Promise<void> {
    const principal = await this.calSessionService.refreshPrincipal();
    const isAuthenticated = Boolean(principal) || this.calSessionService.isAuthenticated();

    this.userProfileStore.Authenticate(isAuthenticated);
    if (!principal) {
      return;
    }

    this.applyPrincipal(principal);
    await this.loadUserPhoto();
  }

  private applyPrincipal(principal: ICvxClaimsPrincipal | null): void {
    if (!principal) {
      return;
    }

    this.userProfileStore.SetUserProfile(principal as any);
    this.userProfileStore.Authenticate(true);

    const email = principal.email || (principal as any)?.userName || '';
    if (email) {
      this.userProfileStore.SetUserEmail(email);
    }
  }

  private async loadUserPhoto(): Promise<void> {
    try {
      const accessToken = await this.calTokenService.getAccessToken(environment.graphScopes);

      if (!accessToken) return;

      const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (!response.ok) return;

      const blob = await response.blob();

      if (this.photoObjectUrl) {
        URL.revokeObjectURL(this.photoObjectUrl);
      }

      this.photoObjectUrl = URL.createObjectURL(blob);
      this.userProfileStore.SetUserImage(this.photoObjectUrl);
    } catch {
      // Ignore photo errors and keep initials fallback.
    }
  }

}
